/* istanbul ignore file */
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import RssiDisplay from './sensors/common/RssiDisplay';
import { connectModalContainerContextToComponent } from '../../../../contexts/ModalContext/ModalContext';
import AdapterSettingsModal from './AdapterSettingsModal';
import formatTimestamp from '../../../../utility/formatTimestamp';
import { getSecondsElapsed } from '../../../../utility/displayValueUtils';
import { selectSessionInformation } from '../../../../redux/slices/sessionSlice';

function AdapterHeader({
  label,
  rssi,
  lastReceived,
  macAddress,
  isAdapterHidden,
  onToggleAdapterHidden,
  setModalJSX,
  adapterChannelGroups,
  isReadOnly,
}) {
  const { timezone } = useSelector(selectSessionInformation);
  const notPushedInTwoHours = getSecondsElapsed(lastReceived) > 7200;
  const formattedLastReceived = formatTimestamp(lastReceived, timezone, 'YYYY-MM-DD HH:mm:ss');
  const handleShowModal = () => {
    if (isReadOnly) return;
    setModalJSX(
      <AdapterSettingsModal
        show
        handleClose={() => setModalJSX((<></>))}
        sensorLabel={label}
        isHidden={isAdapterHidden}
        onToggleHidden={onToggleAdapterHidden}
        adapterChannelGroups={adapterChannelGroups}
      />,
    );
  };

  return (
    <div className="mb-2 px-1">
      <Card style={{
        backgroundColor: '#585858', borderRadius: '10px', color: '#d3d3d3',
      }}
      >
        <Card.Header style={{
          backgroundColor: '#585858', color: '#fff', paddingBottom: '0.5rem', borderRadius: '10px',
        }}
        >
          <Row>
            <Col lg={12} xl={4} className="d-flex align-items-center">
              <h4
                onClick={handleShowModal}
                style={{
                  margin: 0,
                  color: '#fff',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {label}
              </h4>
            </Col>
            <Col
              lg={12}
              xl={2}
              className="d-flex justify-content-xl-center justify-content-end align-items-center"
              style={{ color: '#d3d3d3' }}
            >
              <RssiDisplay rssi={rssi} />
            </Col>
            <Col
              lg={12}
              xl={2}
              className="d-flex justify-content-xl-center justify-content-end align-items-center mr-auto"
              style={{ color: '#d3d3d3' }}
            >
              <span>
                <small>{formattedLastReceived}</small>
                {' '}
                {notPushedInTwoHours && (
                <FontAwesomeIcon icon={faTriangleExclamation} style={{ color: '#f38125' }} className="ml-1" />
                )}
              </span>
            </Col>
            <Col
              lg={12}
              xl={4}
              className="d-flex justify-content-end align-items-center"
              style={{ whiteSpace: 'nowrap', color: '#d3d3d3' }}
            >
              <small style={{ marginRight: '1rem' }}>
                <b>
                  Wired Sensor Adapter -
                  {' '}
                  {macAddress}
                </b>
              </small>
              <FontAwesomeIcon
                icon={faCog}
                size="lg"
                className="pt-0"
                onClick={handleShowModal}
                style={{ cursor: 'pointer' }}
              />
            </Col>
          </Row>
        </Card.Header>
      </Card>
    </div>
  );
}

AdapterHeader.propTypes = {
  label: PropTypes.string.isRequired,
  rssi: PropTypes.number.isRequired,
  lastReceived: PropTypes.number.isRequired,
  macAddress: PropTypes.string.isRequired,
  // handleSettingsClick: PropTypes.func.isRequired,
  setModalJSX: PropTypes.func.isRequired,
  isAdapterHidden: PropTypes.bool.isRequired,
  onToggleAdapterHidden: PropTypes.func.isRequired,
  adapterChannelGroups: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isReadOnly: PropTypes.bool.isRequired,
};
export { AdapterHeader };
export default connectModalContainerContextToComponent(AdapterHeader);
